import { render } from "./App.vue?vue&type=template&id=57e7b81d&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=57e7b81d&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\vue-gpt-sample\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e7b81d"]])

export default __exports__